var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fixed inset-0 z-60" },
    [
      _c(
        "SiteMenuFlyoutLayout",
        {
          attrs: { heading: _vm.heading },
          on: {
            close: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "flex flex-col gap-y-18 py-9 text-lg text-theme" },
            _vm._l(_vm.items, function (item, itemKey) {
              return _c(
                "div",
                {
                  key: itemKey,
                  staticClass: "min-w-fit w-1/2 relative z-10 text-center",
                  class: {
                    "ml-auto": itemKey % 2 === 0,
                    "mr-auto": itemKey % 2 !== 0,
                  },
                },
                [
                  item.link.url
                    ? _c(
                        "a",
                        {
                          staticClass: "block",
                          attrs: { href: item.link.url },
                        },
                        [
                          _c("span", { staticClass: "whitespace-pre-line" }, [
                            _vm._v(_vm._s(item.heading)),
                          ]),
                        ]
                      )
                    : _c(
                        "button",
                        {
                          staticClass: "focus:outline-none",
                          on: {
                            click: function ($event) {
                              return _vm.openMenu(itemKey)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "whitespace-pre-line" }, [
                            _vm._v(_vm._s(item.heading)),
                          ]),
                        ]
                      ),
                  _vm._v(" "),
                  _c("InlineSvg", {
                    staticClass: "item-bg-image m-auto absolute inset-0 -z-10",
                    attrs: {
                      src: item.backgroundImage[0].url,
                      width: item.backgroundImage[0].width,
                      height: item.backgroundImage[0].height,
                      "transform-source": _vm.removeSvgFill,
                      fill: _vm.backgroundImageColour,
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.items, function (item, itemKey) {
        return _c(
          "transition",
          { key: itemKey, attrs: { name: "fade" } },
          [
            _vm.isOpenedMenu(itemKey)
              ? _c("SiteMenuFlyoutMegaSecondarySub", {
                  attrs: {
                    heading: item.heading,
                    "background-image": item.backgroundImage[0],
                    "background-image-colour": _vm.backgroundImageColour,
                    items: item.items,
                  },
                  on: { close: _vm.closeMenu },
                })
              : _vm._e(),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }